import React, { Component } from 'react';
import { connect } from 'react-redux';
import smoothScroll from 'smoothscroll';

import { fetchCategories, searchSite } from '../actions';

import TopSearch from './filters/top-search';
import PostTypes from './filters/post-types';
import CategorySelect from './filters/category-select';
import PostView from './post-view';
import LimitCount from './filters/limit-count';
import Pagination from './filters/pagination';

class SiteSearch extends Component {
	componentWillMount() {
		if ( !this.props.categories.length ) {
			this.props.fetchCategories();
		}
	}

	componentDidUpdate() {
		let doc = document.documentElement,
		    top = ( window.pageYOffset || doc.scrollTop
		          ) - ( doc.clientTop || 0
		          );

		if ( 400 < top ) {
			smoothScroll( document.getElementById( 'search-page-wrap' ) );
		}
	}

	componentWillUpdate( newProps ) {
		if ( this.props.searchTerm !== newProps.searchTerm || this.props.pagination.perPage !== newProps.pagination.perPage || this.props.pagination.pageNum !== newProps.pagination.pageNum || this.props.selectedCategory !== newProps.selectedCategory || this.props.postType !== newProps.postType ) {
			this.props.searchSite( newProps.searchTerm, newProps.selectedCategory, newProps.pagination.perPage, newProps.pagination.pageNum );
		}
	}

	render() {
		return (
			<div>
				<TopSearch />
				<div className="react-component">
					<div className="row">
						<PostTypes />
						<CategorySelect />
					</div>
					<LimitCount totalResults={ this.props.pagination.totalResults } />
					<PostView />
					<Pagination />
				</div>
			</div>
		);
	}
}

function mapStateToProps( { view, pagination, searchTerm, dateRange, categories, selectedCategory, postType } ) {
	return {
		view,
		pagination,
		searchTerm,
		dateRange,
		categories,
		selectedCategory,
		postType
	};
}

export default connect( mapStateToProps, {
	searchSite, fetchCategories
} )( SiteSearch );